<div class="main shadow mt-sm-0 mt-5">
    <div class="heading">Payment Summary</div>
    <div class="feeContainer">
        <div class="feeCal">
            <div>Manyata Fees</div>
            <div>₹ {{totalFees}}</div>
        </div>
        <div class="feeCal">
            <div>Discount</div>
            <div class="discount" [ngStyle]="{'color': discountAmount != 0 ? '#D60F0F' : ''}">- ₹ {{discountAmount}}
            </div>
        </div>
        <div class="feeCal">
            <div>Total Amount</div>
            <div>₹ {{totalAmount}}</div>
        </div>
    </div>
    <div class="couponContainer">
        <div *ngIf="!atPaymentPage">
            <div *ngIf="!isCouponApplied" class="applyCouponText" style="font-weight: 600;">Apply Coupon</div>
            <div *ngIf="isCouponApplied" class="applyCouponText" style="font-weight: 600;">Coupon Applied</div>
            <div class="coupon" [ngStyle]="{'padding': isCouponDisable ? '0px' : ''}">
                <!-- <input type="text" id="couponInput" [(ngModel)]="couponApplied" (input)=inputCoupon($event) class="couponInput"> -->
                <input type="text" id="couponInput" [(ngModel)]="couponApplied" (change)=changeCoupon($event)
                    [attr.disabled]="isCouponDisable ? 'true' : null" class="couponInput" placeholder="Apply Coupon"
                    [ngStyle]="{'width': isCouponDisable ? '100%' : '', 'padding' :  isCouponDisable ? '5px 6px' : '', 'cursor' :  isCouponDisable ? 'not-allowed' : ''}">
                <i class="fa fa-times" *ngIf="couponApplied !== '' && !isCouponDisable"
                    style="color: #ED1556; cursor:pointer;" aria-hidden="true" (click)="removeCouponClick()"></i>
            </div>
            <div *ngIf="invalidCouponCode" class="invalidCoupon">Invalid Coupon Code!</div>
        </div>

        <div *ngIf="atPaymentPage == 'true'">
            <div class="totalTexts">
                <div>Total Amount</div>
                <div>₹ {{totalAmount}}</div>
            </div>
        </div>


    </div>
</div>